import { AxiosError } from 'axios';

import { ZEE_BACKGROUND_API_URL } from '@/constants/apis';
import { apiManager } from '@/helpers/api.manager';
import { ApiResponse } from '@/types/response.type';
import { ZeeBackground } from '@/types/zee.type';

import { CreateZeeBackgroundApiPayload } from './createZeeBackground';

export const updateZeeBackground = async (
  payload: CreateZeeBackgroundApiPayload
): Promise<ApiResponse<ZeeBackground>> => {
  try {
    const response = await apiManager.put(ZEE_BACKGROUND_API_URL, payload, {
      headers: { 'Content-Type': 'application/json' },
    });

    if (response.status !== 200) {
      const error = response as unknown as AxiosError;
      return Promise.reject(error.response?.data);
    }

    return Promise.resolve(response.data);
  } catch (e) {
    return Promise.reject(e);
  }
};
